var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDjurgardensIf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DIF_prim\\xE4ra_sk\\xF6ld",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311.7 379.4",
    style: {
      enableBackground: "new 0 0 311.7 379.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#CFB571;}\n\t.st2{fill:#FFEC0D;}\n\t.st3{fill:#0568AF;}\n\t.st4{fill:#E21F26;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -91.4,
    y: -90.9,
    className: "st0",
    width: 494.6,
    height: 561.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M304.1,31.1l-1.4-6l-6,1.3C222.3,42.2,159.6,5,159,4.6l-3.3-2l-3.2,2C151.8,5,89.3,42.4,14.9,26.7l-6-1.3 l-1.4,6c-0.3,1.2-6.5,28.8-5.1,74.5C6.8,249.3,99.1,342.4,153,374.8l3.2,2l3.2-2c53.8-32.6,145.8-126,149.9-269.3 C310.7,59.8,304.3,32.2,304.1,31.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.8,38.1c-29.1-6.2-50.2-16.7-58.1-21c-13.9,7.7-69.6,34.9-137.2,23c-1.7,10.3-4.7,33.4-3.7,65.4 c1.2,37.3,8.5,71,19.6,101L213.8,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.2,362.1c51.3-32.6,134.7-119.7,140.4-252L90.8,303.3C113.3,330.2,137,350,156.2,362.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M110.2,210.1c7.3,7.8,5.1,16.2-0.1,21l-0.9,0.8l-20.9-22.3l1-0.9C94.7,203.6,103.5,203,110.2,210.1z  M296.9,97.9L85.3,296.6c-17.9-22.6-34.7-49.8-47.4-81.3L224.4,40.1c20.2,3.3,43.6,4.2,68.6-0.3C294.6,49.3,297.2,69.7,296.9,97.9 z M122.8,198.3c-11.8-12.5-30.4-13.5-42.8-1.8l-14.9,14l42,44.6l14.9-14C134.3,229.5,134.6,210.8,122.8,198.3z M159.1,195.6 c-3.5-3.8-9.4-3.9-13.2-0.4c-3.8,3.5-3.9,9.4-0.4,13.2c3.5,3.8,9.4,3.9,13.2,0.4C162.4,205.3,162.6,199.4,159.1,195.6z  M190.8,176.3l-41.9-44.7l-12.9,12.1l41.9,44.7L190.8,176.3z M213,145.1c-3.5-3.8-9.4-3.9-13.2-0.4c-3.8,3.5-3.9,9.4-0.4,13.2 c3.5,3.8,9.4,3.9,13.2,0.4C216.3,154.7,216.5,148.8,213,145.1z M231.1,111.2l13.6-12.8L234,87l-13.6,12.8l-6.9-7.3l13.9-13 L216.6,68L190,93l42,44.6l12.8-12L231.1,111.2z M270.5,91.1c-3.5-3.8-9.4-3.9-13.2-0.4c-3.8,3.5-3.9,9.4-0.4,13.2 c3.5,3.8,9.4,3.9,13.2,0.4C273.8,100.8,274,94.8,270.5,91.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjurgardensIf);
export default __webpack_public_path__ + "static/media/djurgardens-if.8f48a409ed2fa90ea376cfd36ca5521b.svg";
export { ForwardRef as ReactComponent };